export enum SumUserTypeEnum {
  BUSINESSPARTNER = "BUSINESSPARTNER",
  DEFAULT = "DEFAULT",
  SUM_OWNER = "SUM_OWNER",
  APPSUMO = "APPSUMO",
  PROMO = "PROMO",
  CLIENT = "CLIENT"
}
